export default "__VITE_ASSET__0f4d13f2__"